import styled from 'styled-components';

import { BonusCarousel } from '~/src/features/domru-bonus/components/Carusel/styled';
import { breakPoints } from '~/src/features/domru-bonus/styled';

export const CustomCarousel = styled(BonusCarousel)`
    & > div {
        & > div {
            width: 100%;
            & > div {
                &:not(:last-child) {
                    position: relative;
                    height: 100%;

                    &:after {
                        content: '';
                        position: absolute;
                        height: 22px;
                        width: 15%;
                        top: 30px;
                        right: -20px;
                        background: url('/static/images/icons/gradient-right-arrow.svg') 0 0 / contain no-repeat;
                        z-index: 1;

                        @media (max-width: ${breakPoints.sDesktop}) {
                            top: 35px;
                            right: -15px;
                        }

                        @media (max-width: ${breakPoints.laptop}) {
                            top: 25px;
                            right: -15px;
                        }

                        @media (max-width: ${breakPoints.tablet}) {
                            top: 22px;
                            right: -15px;
                        }

                        @media (max-width: ${breakPoints.mobile}) {
                            top: 28px;
                            right: -15px;
                            width: 35px;
                        }
                    }
                }
            }
        }
    }
`;
